import React, { useEffect } from 'react';
import { store } from 'redux/store';
import { setCurrentTab } from 'redux/reducers/agroLayoutReducer';
import MapGridSection from 'components/Meteorology/Weather/Similarity/MapGridSection';
import DataTableSection from 'components/Meteorology/Weather/Similarity/DataTableSection';
import EnsembleDialog from 'components/Meteorology/Weather/Similarity/EnsembleDialog';
import SimilarityMobile from 'components/Meteorology/Agro/Similarity/Mobile';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function Similarity() {
  const isMobile = useIsMobile();

  useEffect(() => {
    store.dispatch(setCurrentTab('similarity'));
  }, []);

  if (isMobile) {
    return <SimilarityMobile />;
  }

  return (
    <div className="p-4 bg-white shadow-sm rounded-lg">
      <MapGridSection />
      <DataTableSection />
      <EnsembleDialog />
    </div>
  );
}
